import { Link } from "react-router-dom";
import { Instagram, Music2, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ink border-t-2 border-white/10 mt-12">
      {/* Pink stripe divider */}
      <div className="stripe-divider" />

      <div className="container-x py-16 md:py-20 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-2">
            <img
              src="/mld-logo.png"
              alt="MLD logo"
              className="w-14 h-14 object-contain"
            />
            <h3 className="font-display text-4xl text-white">MISS LOLLY DESIGNS</h3>
          </div>
          <p className="mt-3 text-rose font-bold uppercase tracking-[0.2em] text-xs">
            Where digital futures meet handmade beginnings.
          </p>
          <p className="mt-6 text-sm text-white/60 max-w-md leading-relaxed">
            Custom denim, rhinestone bling, vinyl press and HTV — built like wearable
            art. London-style street energy for ages 8 to adult.
          </p>
          <div className="mt-8 flex gap-3">
            <a href="https://www.instagram.com/misslollydesigns" target="_blank" rel="noreferrer" data-testid="footer-instagram"
               className="w-12 h-12 border-2 border-white flex items-center justify-center text-white hover:bg-rose hover:border-rose transition">
              <Instagram size={18} />
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" data-testid="footer-tiktok"
               className="w-12 h-12 border-2 border-white flex items-center justify-center text-white hover:bg-rose hover:border-rose transition">
              <Music2 size={18} />
            </a>
            <a href="mailto:MissLollyDesigns@gmail.com" data-testid="footer-email"
               className="w-12 h-12 border-2 border-white flex items-center justify-center text-white hover:bg-rose hover:border-rose transition">
              <Mail size={18} />
            </a>
          </div>
        </div>

        <div>
          <p className="overline mb-4">Studio</p>
          <ul className="space-y-3 text-sm text-white/80 font-medium uppercase tracking-wider">
            <li><Link to="/about" className="hover:text-rose">About</Link></li>
            <li><Link to="/workshops" className="hover:text-rose">Workshops</Link></li>
            <li><Link to="/parties" className="hover:text-rose">Parties</Link></li>
            <li><Link to="/gallery" className="hover:text-rose">Gallery</Link></li>
            <li><Link to="/jacket-questionnaire" className="hover:text-rose">Jacket brief</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Help</p>
          <ul className="space-y-3 text-sm text-white/80 font-medium uppercase tracking-wider">
            <li><Link to="/faq" className="hover:text-rose">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-rose">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-rose">Studio login</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t-2 border-white/10">
        <div className="container-x py-5 flex flex-col md:flex-row justify-between gap-3 text-[11px] text-white/40 uppercase tracking-[0.2em]">
          <p>© {new Date().getFullYear()} Miss Lolly Designs · Hypha Studio, Chatham</p>
          <p className="text-gold">Denim · Vinyl · Bling · Built by hand.</p>
        </div>
      </div>
    </footer>
  );
}
